import styled from '@emotion/styled';

const ContentLayout = styled.div<{ haveSubHeader?: boolean }>`
  padding: 0 20px;
  padding-top: ${({ haveSubHeader }) => (haveSubHeader ? '52px' : '0')};
  background-color: var(--dk-bg-subtle, rgb(249, 250, 251));
`;

const ApprovalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 0;
`;

const CenterLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 80vh;
  color: var(--dk-text-dim, #b7bbc2);
`;
export { ApprovalContentContainer, CenterLayout, ContentLayout };
